import { supabase } from './supabase';

/**
 * Verrou de suppression par mot de passe (parité A2).
 * Avant une suppression définitive, on re-vérifie le mot de passe du restaurateur
 * connecté via Supabase Auth (re-authentification), comme le legacy. Empêche une
 * suppression accidentelle/par un tiers sur une session ouverte.
 */

/** Email du restaurateur connecté (pour la re-vérification). Null si pas de session. */
export async function currentUserEmail(): Promise<string | null> {
  const { data } = await supabase.auth.getUser();
  return data.user?.email ?? null;
}

/**
 * Vérifie le mot de passe sans casser la session courante.
 * Garde-fou : refuse tout de suite si email/mot de passe vide (pas d'appel réseau).
 * Renvoie true si le mot de passe est correct.
 */
export async function verifyPassword(email: string | null, password: string): Promise<boolean> {
  if (!email || !password.trim()) return false;
  // signInWithPassword renvoie une erreur si le mot de passe est faux. En cas de succès
  // la session est rafraîchie pour le même utilisateur (pas de changement de compte).
  const { error } = await supabase.auth.signInWithPassword({ email, password });
  return !error;
}
